import { render, staticRenderFns } from "./ParcInfo.vue?vue&type=template&id=0e1b6998&"
import script from "./ParcInfo.vue?vue&type=script&lang=js&"
export * from "./ParcInfo.vue?vue&type=script&lang=js&"
import style0 from "./ParcInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports